<template>
  <b-card
    no-body
    class="card-statistics"
  >
    <b-card-header>
      <b-card-title>{{ $t('dashboard_lbl.statistics') }}</b-card-title>
    </b-card-header>
    <b-card-body class="statistics-body dashboard-stats">
      <b-row>
        <b-col
          xl="4"
          sm="6"
          style="margin-bottom: 2rem;"
        >
          <b-media no-body>
            <b-media-aside
              class="mr-2"
            >
              <b-avatar
                size="42"
                :class="'text-primary bg-transparent position-relative'"
              >
                <svg-icon
                  type="mdi"
                  :path="path"
                />
                <span class="v-avatar__underlay" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h6>{{ currentPlan.trackingUsed }}</h6>
              <h4 class="font-weight-bolder mb-0">
                {{ $t('dashboard_lbl.tracking_used') }}
              </h4>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col
          xl="4"
          sm="6"
          style="margin-bottom: 2rem;"
        >
          <b-media no-body>
            <b-media-aside
              class="mr-2"
            >
              <b-avatar
                size="42"
                :class="'text-success bg-transparent position-relativ'"
              >
                <svg-icon
                  type="mdi"
                  :path="path1"
                />
                <span class="v-avatar__underlay" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h6>{{ currentPlan.trackingLimit }}</h6>
              <h4 class="font-weight-bolder mb-0">
                {{ $t('dashboard_lbl.tracking_limit') }}
              </h4>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col
          xl="4"
          sm="6"
          style="margin-bottom: 2rem;"
        >
          <b-media no-body>
            <b-media-aside
              class="mr-2"
            >
              <b-avatar
                size="42"
                :class="'text-danger  bg-transparent position-relative'"
              >
                <svg-icon
                  type="mdi"
                  :path="path2"
                />
                <span class="v-avatar__underlay" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h6>{{ currentPlan.validTo }}</h6>
              <h4 class="font-weight-bolder mb-0">
                {{ $t('dashboard_lbl.valid_to') }}
              </h4>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'

import SvgIcon from '@jamescoyle/vue-icon'
import {
  mdiReceiptTextOutline, mdiChartPie, mdiChartScatterPlot, mdiDomain, mdiPrinterPos, mdiBallot,
} from '@mdi/js'
import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    SvgIcon,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      currentPlan: {},
      path: mdiDomain,
      path1: mdiChartPie,
      path2: mdiChartScatterPlot,
      path3: mdiDomain,
      path4: mdiPrinterPos,
      path5: mdiBallot,
    }
  },
  mounted() {
    this.getMyCurrentPlan()
  },
  methods: {
    getMyCurrentPlan() {
      const token = useJwt.getToken()
      useJwt
        .getUserCurrentPlan(token)
        .then(response => {
          this.currentPlan = response.data
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error fetching current plan',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>
<style>
.v-avatar__underlay {
    background: currentColor;
    opacity: 0.12;
    border-radius: inherit;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    pointer-events: none;
}
</style>
